<template>
  <c-box :mx="{ base: '-15px', md: '0' }">
    <c-heading as="h1" size="lg">
      {{ $t("logout.message.reLogin") }}
    </c-heading>
  </c-box>
</template>

<script lang="ts">
import { CBox, CHeading } from "@chakra-ui/vue";
import { defineComponent } from "vue";

export default defineComponent({
  name: "ReLogin",
  components: {
    CBox,
    CHeading,
  },
  beforeMount() {
    if (this.$route.query.sessionExpired) {
      this.$store.commit("showGeneralError", {
        dialogTitle: this.$t("dialog.sessionExpired.title"),
        dialogText: this.$t("dialog.sessionExpired.body"),
      });
    }
    this.$store.dispatch("localLogout").then(() => {
      setTimeout(() => {
        this.$router.push("/login");
      }, 5000);
    });
  },
});
</script>
